(function () {
  // 菜单随页面滚动进行高亮更换
  const indexBlock = document.getElementById('index')
  const userGrowthBlock = document.getElementById('user-growth')
  const scrmBlock = document.getElementById('SCRM')
  const o2oBlock = document.getElementById('O2O')
  const privateTrafficBlock = document.getElementById('private-traffic')
  const distributionBlock = document.getElementById('distribution')
  const dataIntelligenceBlock = document.getElementById('data-intelligence')
  const smartSupplyChainBlock = document.getElementById('smart-supply-chain')
  const blocks = [ 
    indexBlock, userGrowthBlock, scrmBlock, 
    o2oBlock, privateTrafficBlock, distributionBlock, 
    dataIntelligenceBlock, smartSupplyChainBlock 
  ]

  const menuItems = document.getElementById('header').getElementsByClassName('tab-item')
  const menuItemsMobile = document.getElementById('header').getElementsByClassName('tab-font-mobile')
  let menuItemsMap = {}
  let menuItemsMapMobile = {}
  Array.from(menuItems).forEach(menuItem => {
    const button = menuItem.getElementsByTagName('buttom')
    if (button && button[0]) {
      return
    }

    try {
      const id = menuItem.getElementsByTagName('a')[0].getAttribute('href').replace('#', '')
      menuItemsMap[id] = menuItem
    } catch (e) {
      console.log(e)
    }
  })
  
  Array.from(menuItemsMobile).forEach(menuItem => {
    try {
      const id = menuItem.getAttribute('id')
      menuItemsMapMobile[id] = menuItem
      //为移动端导航栏添加点击事件
      menuItem.parentNode.addEventListener('click',() =>{
        const target = document.getElementById(id.replace('navigation','darkanchor'))
        smoothjump(target)
      })
    } catch (e) {
      console.log(e)
    }
  })
  const menuItemsMapKeys = Object.keys(menuItemsMap)
  window.addEventListener('scroll', debounce(function () {
    blocks.some(block => {
      if (isVisibleInWindow(block, 120)) {
        // 更新菜单高亮
        menuItemsMapKeys.forEach(id => {
          if (id === block.getAttribute('id')) {
            menuItemsMap[id].classList.add('menu-item-hover')
            menuItemsMapMobile[id+'-navigation'] ? menuItemsMapMobile[id+'-navigation'].classList.add('tab-item-mobile-hover') : null
          } else {
            menuItemsMap[id].classList.remove('menu-item-hover')
            menuItemsMapMobile[id+'-navigation'] ? menuItemsMapMobile[id+'-navigation'].classList.remove('tab-item-mobile-hover') : null
          }
        })
        return true
      }
      return false
    })
  }, 80))




  function listenHeader(){
    let button = document.getElementById('register-btn')
    button.addEventListener('click',function(e){
      window.location.href='#retention-darkanchor'
    })
    button = document.getElementById('register-btn-mobile')
    button.addEventListener('touchstart',(e) =>{
      smoothjump(document.getElementById('retention-darkanchor'))
      e.preventDefault()
    })
    const logo = document.getElementsByClassName('logo-frame')[0]
    logo.addEventListener('touchstart',(e) => {
      smoothjump(document.getElementById('index-darkanchor'))
      e.preventDefault()
    })
  }
  function listennavigation(){
    let button = document.getElementById('navigation')
    button.addEventListener('click',function(){
      let depend = false
      document.getElementsByClassName('navigation-items')[0].classList.forEach(classitem =>{
        if (classitem === 'navigation-items-hover') return depend = true
      })
      if (depend) {document.getElementsByClassName('navigation-items')[0].classList.remove('navigation-items-hover')}
      else document.getElementsByClassName('navigation-items')[0].classList.add('navigation-items-hover')
      
    })
  }
  listenHeader()
  listennavigation()
})()